import { ListGroup } from "react-bootstrap";

const RfqItemList = ({ items }) => (
  <>
    <h5>RFQ Items</h5>
    <ListGroup className="mb-4 shadow-sm">
      {items.map(item => (
        <ListGroup.Item key={item._id}>
          <div className="d-flex justify-content-between">
            <strong>{item.product.productName}</strong>
            <span>{item.required_quantity} {item.quantity_unit}</span>
          </div>
          <small>Quality: {item.quality}</small>
        </ListGroup.Item>
      ))}
    </ListGroup>
  </>
);

export default RfqItemList;
